import { toast } from 'react-toastify'
import instance from '../../utils/Axios'

import { GET_CREATOR_METADATA, GET_CREATOR_METADATA_LOADING } from './Types'

export const getCreatorMetadata = () => (dispatch) => {
  dispatch({
    type: GET_CREATOR_METADATA_LOADING,
    payload: true,
  })
  instance
    .get('/creator-metadata')
    .then((res) => {
      dispatch({
        type: GET_CREATOR_METADATA,
        payload: res.data.message,
      })
    })
    .catch(() => {
      toast.error('Error fetching creator metadata')
    })
    .finally(() => {
      dispatch({
        type: GET_CREATOR_METADATA_LOADING,
        payload: false,
      })
    })
}
